<template>
  <div class="router-view">
    <router-view v-slot="{ Component, route }">
      <transition name="router">
        <component :is="Component" :key="route.name" v-bind="route.props" />
      </transition>
    </router-view>
    <div
      class="router-backdrop bg-glass-dark overflow-hidden"
      @click="close"
      @touchmove.stop.prevent
      @wheel.stop.prevent
    ></div>
  </div>
</template>

<script lang="ts">
import navigate from "../routes/navigate"

export default {
  methods: { close: () => navigate() },
  props: [] as const,
}
</script>
